import { useEffect, useRef } from "react";
import { CheckCircle2, KeyRound, MessageCircle } from "lucide-react";
import { Link, useSearchParams } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { PRICE, PRICE_RABIETAS, waLink } from "@/lib/api";
import { useCookieConsent } from "@/components/CookieConsentContext";

const WA_ORDER_HELP = waLink("Hola, he completado una compra y necesito ayuda con el acceso.");

export default function ThankYou() {
  const { consent } = useCookieConsent();
  const [searchParams] = useSearchParams();
  const isRabietas = searchParams.get("product_id") === "rabietas-2-3";
  const purchaseTracked = useRef(false);

  useEffect(() => {
    if (!consent.marketing || typeof window.fbq !== "function" || purchaseTracked.current) return;
    const value = isRabietas ? PRICE_RABIETAS : PRICE;
    window.fbq("track", "Purchase", { value, currency: "EUR" });
    purchaseTracked.current = true;
  }, [consent.marketing, isRabietas]);

  return (
    <main data-testid="thank-you-page" className="min-h-screen grid place-items-center px-5 py-16">
      <div className="w-full max-w-lg">
        <Link to="/" className="text-2xl" aria-label="En Dos Mundos, inicio">
          <Logo />
        </Link>
        <section className="mt-8 rounded-lg border border-[var(--sand)] bg-white p-6 shadow-[0_12px_34px_rgba(52,56,50,0.08)] sm:p-8">
          <div className="grid size-12 place-items-center rounded-lg bg-[var(--sage)]/30 text-[var(--forest)]">
            <CheckCircle2 size={26} aria-hidden="true" />
          </div>
          <h1 className="mt-5 font-display text-3xl">¡Gracias por tu compra!</h1>
          <p className="mt-3 text-[#5a4f46]">
            {isRabietas
              ? "Si acabas de completar el pago de Rabietas en Stripe, recibirás el acceso en el correo utilizado durante el checkout. Si no lo recibes, escríbenos por WhatsApp."
              : "Si acabas de completar el pago con tarjeta en Stripe, revisaremos el pedido y te enviaremos el código de acceso por WhatsApp al número que indicaste."}
          </p>
          <div className="mt-6 border-t border-[var(--sand)] pt-5">
            <p className="font-semibold">¿No recibes tu código?</p>
            <p className="mt-1 text-sm text-[#5a4f46]">Escríbenos y te ayudaremos a entrar al pack.</p>
            <a href={WA_ORDER_HELP} target="_blank" rel="noreferrer" className="btn-accent mt-4 w-full">
              <MessageCircle size={18} aria-hidden="true" /> Contactar por WhatsApp
            </a>
          </div>
          <Link to="/acceso" className="mt-4 inline-flex items-center gap-2 text-sm font-semibold text-[var(--forest)] underline">
            <KeyRound size={16} aria-hidden="true" /> Ya tengo mi código de acceso
          </Link>
        </section>
        <Link to="/" className="mt-6 inline-block text-sm text-[#5a4f46] underline">Volver a En Dos Mundos</Link>
      </div>
    </main>
  );
}
